module.exports = __webpack_public_path__ + "static/assets/7e8a898241bdb88d80f4ae04c7aa26d3.svg";